import { useTranslation } from 'react-i18next'

import { QA_NAME_CONFIRMATION } from '../../../../../constants/qa'
import { RENTAL_PORTAL_VIEWING_STATUS } from '../../../../../constants/rentalPortal'
import {
  useDateLocale,
  useNotification,
  useTimeZone,
} from '../../../../../hooks'
import { stopPropagation } from '../../../../../utils/events'
import { ConfirmationModal } from '../../../../Confirmation'
import {
  getViewingObjectName,
  patchMockViewing,
  VIEWING_STATUS_CHANGE_COPY,
} from '../../../../RentalPortalViewing'
import { ViewingRescheduleModal } from '../../../RentalPortalViewingProfile'
import {
  VIEWING_ACTION_ARCHIVE,
  VIEWING_ACTION_ARCHIVE_MASS,
  VIEWING_ACTION_BOOK,
  VIEWING_ACTION_CANCEL,
  VIEWING_ACTION_RESCHEDULE,
} from '../../RentalPortalViewings.constants'

import ArchiveIcon from '../../../../../icons/delete.svg'

export function useRentalPortalViewingTableActions({
  setModal,
  onBook,
  onClose,
  onPerformAction,
  onReload,
}) {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const cancelCopy =
    VIEWING_STATUS_CHANGE_COPY[RENTAL_PORTAL_VIEWING_STATUS.cancelled]

  function handleRescheduled() {
    handleAddSuccessNotification(
      'RentalPortal.ViewingRescheduledNotificationKey'
    )

    onReload()
  }

  function handleCancel(item) {
    return patchMockViewing(item.id, {
      status: RENTAL_PORTAL_VIEWING_STATUS.cancelled,
    })
      .then(() => {
        onClose()

        handleAddSuccessNotification(cancelCopy.notificationKey)

        return onReload()
      })
      .catch(() => {
        onClose()

        handleAddErrorNotification({
          title: t('RentalPortal.ViewingStatusChangeErrorKey'),
        })
      })
  }

  function setItemAction(action, item) {
    switch (action) {
      case VIEWING_ACTION_BOOK:
        onBook(item)
        break
      case VIEWING_ACTION_ARCHIVE:
        setModal(
          <ConfirmationModal
            actionButtonsProps={{
              submitProps: { beforeIconProps: { Icon: ArchiveIcon } },
              submitText: t('RentalPortal.ViewingArchiveActionOptionKey'),
            }}
            description={t('RentalPortal.ViewingArchiveConfirmationTextKey', {
              name: getViewingObjectName({
                locale,
                t,
                timezone,
                viewing: item,
              }),
            })}
            qaName={QA_NAME_CONFIRMATION}
            onCancel={onClose}
            onSubmit={event => {
              stopPropagation(event)

              return onPerformAction({
                action: VIEWING_ACTION_ARCHIVE_MASS,
                ids: [item.id],
                onRetry: () => setItemAction(action, item),
              })
            }}
          />
        )
        break
      case VIEWING_ACTION_RESCHEDULE:
        setModal(
          <ViewingRescheduleModal
            viewingData={item}
            onClose={onClose}
            onRescheduled={handleRescheduled}
          />
        )
        break
      case VIEWING_ACTION_CANCEL:
        setModal(
          <ConfirmationModal
            actionButtonsProps={{
              submitText: t(cancelCopy.submitKey),
            }}
            description={t(cancelCopy.descriptionKey, {
              applicant: item.applicant_label,
            })}
            qaName={QA_NAME_CONFIRMATION}
            onCancel={onClose}
            onSubmit={() => handleCancel(item)}
          />
        )
        break
      default:
        return null
    }
  }

  return { setItemAction }
}
